<template>
	<AppDropdown
		:popover-props="{
			distance: 0,
			theme: 'no-arrows',
			placement: 'bottom-start',
		}"
		:is-loading="loading"
	>
		<template #trigger="{ isOpen }">
			<slot :is-open="isOpen" />
		</template>

		<BookmarksDropdownSkeleton v-if="loading" />
		<BookmarksDropdownSelectList
			v-else
			:key="modules?.join('-')"
			:modules="modules"
			@update:model-value="onBookmarkSelect($event)"
		/>
	</AppDropdown>
</template>

<script setup lang="ts">
import BookmarksDropdownSkeleton from './BookmarksDropdownSkeleton.vue';
import BookmarksDropdownSelectList from './BookmarksDropdownSelectList.vue';
import { AppDropdown } from '@/features/App';
import {
	useBookmarksDropdownQuery,
	type BookmarksDropdownQuery,
} from '@/generated/graphql';
import { hideAllPoppers } from 'floating-vue';

const emit = defineEmits<{
	(
		e: 'update:modelValue',
		bookmark: BookmarksDropdownQuery['BookmarksList'][0]
	): void;
}>();

const props = defineProps<{
	modules?: string[] | undefined;
}>();

const onBookmarkSelect = (
	bookmark: BookmarksDropdownQuery['BookmarksList'][0]
) => {
	emit('update:modelValue', bookmark);
	hideAllPoppers();
};

const { loading } = useBookmarksDropdownQuery(
	{
		filters: {
			modules: props.modules,
			isShared: true,
		},
	},
	{
		notifyOnNetworkStatusChange: true,
	}
);
</script>
